<div class="hangfire-handoff">
  <p *ngIf="state === 'opening'">{{ 'hangfireHandoff.opening' | translate }}</p>

  <ng-container *ngIf="state === 'failed'">
    <p>{{ 'hangfireHandoff.failed' | translate }}</p>
    <a routerLink="/">{{ 'hangfireHandoff.backToFlow' | translate }}</a>
  </ng-container>

  <ng-container *ngIf="state === 'notAdmin'">
    <p>{{ 'hangfireHandoff.notAdmin' | translate }}</p>
    <a routerLink="/">{{ 'hangfireHandoff.backToFlow' | translate }}</a>
  </ng-container>
</div>
